<template>
  <div class="container">
    <el-tabs v-model="activeName" @tab-click="handleTabsChange">
      <el-tab-pane label="待点评" name="waitComment">
        <wait-comment :visible="activeName === 'waitComment'"></wait-comment>
      </el-tab-pane>
      <el-tab-pane label="已点评" name="alreadyComment">
        <already-comment
          :visible="activeName === 'alreadyComment'"
        ></already-comment>
      </el-tab-pane>
      <el-tab-pane label="点评明细" name="commentInfo">
        <comment-info :visible="activeName === 'commentInfo'"></comment-info>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import waitComment from "./waitComment/index.vue";
import alreadyComment from "./alreadyComment/index.vue";
import commentInfo from "./commentInfo/index.vue";
export default {
  components: {
    waitComment,
    alreadyComment,
    commentInfo,
  },
  data() {
    return {
      activeName: "waitComment",
    };
  },
  created() {
    if (this.$route.query.from) {
      this.activeName = this.$route.query.from;
    } else {
      const pageCache = sessionStorage.getItem(
        "interaction-management-class-comment-page-cache"
      );
      if (pageCache) {
        let pageCacheJSON = JSON.parse(pageCache);
        if (pageCacheJSON.tab) {
          this.activeName = pageCacheJSON.tab;
        }
      }
    }
  },
  methods: {
    handleTabsChange() {
      sessionStorage.setItem(
        "interaction-management-class-comment-page-cache",
        JSON.stringify({
          tab: this.activeName,
        })
      );
    },
  },
};
</script>
<style scoped lang="scss">
.container {
  background-color: #ffffff;
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  overflow: hidden;
}
</style>
